/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignJustify = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 12h18" }],
    ["path", { d: "M3 18h18" }],
    ["path", { d: "M3 6h18" }]
  ]
];

export { AlignJustify as default };
//# sourceMappingURL=align-justify.js.map
